import { type FC, Fragment, useMemo } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { ServicesCard, Text } from 'components'

import Pillars from './Pillars'
import { services, serviceCategories, resolveLang } from './servicesCatalog'
import styles from './ServicesPage.module.scss'

const ServicesPage: FC = () => {
  const { i18n } = useTranslation()
  const lang = resolveLang(i18n.language)

  const groups = useMemo(
    () =>
      serviceCategories
        .map(category => ({ category, items: services.filter(s => s.category === category) }))
        .filter(group => group.items.length),
    []
  )

  return (
    <Fragment>
      <section className={styles.hero} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/services.png)` }}>
        <div className={styles.hero__overlay} />
        <div className={classNames('container', styles.hero__inner)}>
          <div className={styles.hero__pills}>
            <span className={styles.hero__pill}>
              <Text text='servicesHeroDesign' />
            </span>
            <span className={styles.hero__pillDivider} aria-hidden />
            <span className={styles.hero__pill}>
              <Text text='servicesHeroInstallation' />
            </span>
          </div>
          <Text text='servicesHeroHeadline' className={styles.hero__headline} tagName='h1' />
        </div>
      </section>

      <div className={styles.page}>
        <Pillars />

        <div className={classNames('container', styles.block)}>
          <div className={styles.block__heading}>
            <span className={styles.block__accent} aria-hidden />
            <Text className={styles.block__title} text='servicesPageIntro' />
          </div>

          {groups.map(group => (
            <section className={styles.group} key={group.category}>
              <div className={styles.group__heading}>
                <span className={styles.group__accent} aria-hidden />
                <Text className={styles.group__title} text={group.category} tagName='h2' />
              </div>
              <div className={styles.block__cards}>
                {group.items.map(service => (
                  <ServicesCard
                    key={service.slug}
                    to={`/services/${service.slug}`}
                    title={service.titles[lang] || service.titles.am}
                    Icon={service.Icon}
                    HoverIcon={service.HoverIcon}
                  />
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default ServicesPage
